export const teamKeys = Object.freeze({
  all: ['teams'],
  list: () => ['teams', 'list'],
  detail: (uuid) => ['teams', 'detail', uuid],
});
